import Decimal from 'decimal.js'

export const TOKEN_KEY = 'QUIX_TOKEN'
export const ROLE_ID = 'quixRole'
export enum AuthOperation {
    USER_LOGIN = 1,
    ADMIN_LOGIN = 2,
    LOGOUT = 3,
    USER_ONBOARDING=4,
}

export enum JobStatus {
    RUNNING = 0,
    TERMINATING = 1,
    COMPLETED = 2,
    CANCELLED = 3,
    UNRUNNABLE = 4,
    IN_QUEUE = 5,
}

export enum UserType {
    FREE = 'FREE',
    PAID = 'PAID',
    INTERNAL = 'INTERNAL',
    DISCOUNTED = 'DISCOUNTED'
}
  

/**
    * @description
    * This constant is used to calculate the amount based on the credits
    * @example 1 credit = 1.55 euros
**/
export const AMOUNT_PER_CREDIT = new Decimal(1.55);

export const QUIX_SALES_EMAIL = "sales@quixquantum.com"